const doc = [({"ja":({"adminConstantPromotionType":({"promotionCode":"コード入力", "goto":"Go To トラベル", "member":"会員割引", "official":"公式サイト限定割引", "consecutiveStay":"連泊割引"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;